import React from 'react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import { Dropdown } from 'semantic-ui-react';

class Customerdropdown extends React.Component {

  state = {
    load: false,
  }


  componentDidMount() {
    this.getCustomer();
  }

  getCustomer = () => {
    let context = this;
    this.setState({ load: true, message: 'getting Cuatomer!!!', customer: this.props.customer })
    $.ajax({
      type: 'POST',
      url: Server()+'machinesales/getcustomer.php',
      success: function(data)
      {
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setCustomer(data);
          context.setState({ data: data })
        } catch (e) {

        }
      },
      error: function(e)
      {
        console.log(e);
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  setCustomer = (data) => {
    let context = this;
    var x = [];
    data.map((y) => {
      let text = y.id+'->'+y.name+'->'+y.taluk+'->'+y.mobile;
      x.push({key: text, text: text, value: y.id});
    });
    try {
      context.setState({
        customerOption: x,
      });
    } catch (e) {

    }
    console.log(x);
  }

  customer = (f, { value }) => {
    this.setState({ customer: value });
    this.props.update(value, this.state.data);
  }

  render() {
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Dropdown placeholder='Customer' style={{ borderColor: '#5A9CBB' }}
         fluid search selection onChange={this.customer} fluid
         options={this.state.customerOption} value={this.state.customer} />
      </div>
    );
  }
}

export default Customerdropdown;
